var map = {
	"./FAQ.pdf": 60135,
	"./Guidelines.pdf": 78143,
	"./TMC Guidelines.pdf": 78223,
	"./Terms and Conditions.pdf": 21167,
	"./User Guide.pdf": 32399,
	"./blank.pdf": 98021,
	"./instruction.pdf": 18662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16054;